import timg1 from '../images/team/1.png'
import timg2 from '../images/team/2.png'
import timg3 from '../images/team/3.png'
import timg4 from '../images/team/4.png'





const Teams = [
   {
      Id: '1',
      img: timg1,
      title: 'Đăng Tâm',
      subtitle: 'Nhóm trưởng',
   },
   {
      Id: '2',
      img: timg2,
      title: 'Lã Việt Hùng',
      subtitle: 'Nhóm phó',
   }
]

export default Teams;